// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ─── Timeline / Experience ──────────────────────────────── */
.experience-section {
  margin-top: 64px;
  padding: 80px 10%;
  background-color: var(--bg-surface);
}
@media (max-width: 768px) {
  .experience-section {
    padding: 60px 5%;
  }
}

.experience-header {
  text-align: center;
  margin-bottom: 56px;
}
.experience-header h1 {
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: -0.5px;
  margin: 0 0 12px;
  color: var(--text) !important;
}

.experience-rule {
  width: 48px;
  height: 3px;
  background: var(--accent);
  border-radius: 2px;
  margin: 0 auto;
}

/* ── Vertical Timeline lib overrides ─────────────────────── */
.vertical-timeline::before {
  background: var(--border) !important;
  width: 2px !important;
}

.vertical-timeline-element-icon {
  background: var(--accent) !important;
  box-shadow: 0 0 0 3px var(--accent-soft), 0 0 0 5px var(--border) !important;
}
.vertical-timeline-element-icon svg {
  color: #fff !important;
}

.svg-inline--fa {
  color: #fff !important;
}

.vertical-timeline-element-content {
  background: var(--bg-card) !important;
  border: 1px solid var(--border) !important;
  border-radius: 10px !important;
  box-shadow: none !important;
  padding: 0 !important;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.vertical-timeline-element-content:hover {
  border-color: rgba(96, 165, 250, 0.35) !important;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.3) !important;
}

.vertical-timeline-element-content-arrow {
  border-right-color: var(--border) !important;
}

.vertical-timeline-element-date {
  color: var(--text-muted) !important;
  font-size: 0.78rem !important;
  font-weight: 600 !important;
  font-family: "SF Mono", "Fira Code", Consolas, monospace !important;
  opacity: 1 !important;
}

/* ── Card inner layout ───────────────────────────────────── */
.tl-header {
  padding: 20px 20px 0;
}

.tl-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}

.tl-title {
  font-size: 1rem !important;
  font-weight: 700 !important;
  color: var(--text) !important;
  margin: 0 !important;
  line-height: 1.3;
}

.tl-duration {
  font-size: 0.68rem;
  font-weight: 700;
  font-family: "SF Mono", "Fira Code", Consolas, monospace;
  color: var(--accent) !important;
  background: var(--accent-soft);
  border: 1px solid rgba(96, 165, 250, 0.2);
  border-radius: 4px;
  padding: 2px 8px;
  white-space: nowrap;
  flex-shrink: 0;
}

.tl-company {
  font-size: 0.85rem !important;
  font-weight: 500 !important;
  color: var(--accent) !important;
  margin: 4px 0 0 !important;
}

.tl-company-link {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  text-decoration: none;
  background: var(--accent-soft);
  border: 1px solid rgba(96, 165, 250, 0.3);
  border-radius: 6px;
  padding: 2px 8px;
  transition: background 0.2s, border-color 0.2s;
}
.tl-company-link:hover {
  background: rgba(96, 165, 250, 0.2);
  border-color: var(--accent);
}

.tl-company-link-icon {
  font-size: 0.6rem !important;
  color: var(--accent) !important;
  opacity: 0.8;
}

.tl-description {
  font-size: 0.85rem !important;
  color: var(--text-muted) !important;
  line-height: 1.6 !important;
  margin: 10px 20px 0 !important;
}

/* ── Tech tags ───────────────────────────────────────────── */
.tl-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 12px 20px 0;
}

.tl-tag {
  font-size: 0.68rem;
  font-weight: 700;
  font-family: "SF Mono", "Fira Code", Consolas, monospace;
  padding: 2px 8px;
  border-radius: 4px;
  background: transparent;
  border: 1px solid var(--border);
  color: var(--text-muted) !important;
  transition: border-color 0.2s, color 0.2s;
}
.tl-tag:hover {
  border-color: var(--accent);
  color: var(--accent) !important;
}

/* ── Collapsible missions ────────────────────────────────── */
.tl-missions {
  padding: 12px 12px 12px;
  margin-top: 8px;
  border-top: 1px solid var(--border);
}

.tl-section {
  margin-bottom: 2px;
}

.tl-section-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 7px 10px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  text-align: left;
  transition: background 0.15s;
}
.tl-section-toggle span {
  font-size: 0.825rem;
  font-weight: 600;
  color: var(--text) !important;
}
.tl-section-toggle svg {
  color: var(--text-muted) !important;
  font-size: 1rem !important;
  flex-shrink: 0;
}
.tl-section-toggle:hover {
  background: var(--accent-soft);
}
.tl-section-toggle:hover span {
  color: var(--accent) !important;
}

.tl-task-list {
  margin: 4px 0 8px 16px;
  padding: 0;
  list-style: none;
}

.tl-task {
  font-size: 0.8rem;
  color: var(--text-muted) !important;
  line-height: 1.5;
  padding: 3px 0 3px 12px;
  position: relative;
}
.tl-task::before {
  content: "›";
  position: absolute;
  left: 0;
  color: var(--accent) !important;
  font-weight: 700;
}

@media screen and (max-width: 1170px) {
  .vertical-timeline-element-date {
    color: var(--text-muted) !important;
    margin-top: 8px !important;
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Timeline.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,+DAAA;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,mCAAA;AACF;AACE;EALF;IAK8B,gBAAA;EAG5B;AACF;;AADA;EACE,kBAAA;EACA,mBAAA;AAIF;AAFE;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,6BAAA;AAIJ;;AAAA;EACE,WAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AAGF;;AAAA,+DAAA;AAEA;EACE,oCAAA;EACA,qBAAA;AAEF;;AACA;EACE,oCAAA;EACA,4EAAA;AAEF;AAAE;EAAM,sBAAA;AAGR;;AAAA;EAAkB,sBAAA;AAIlB;;AAFA;EACE,qCAAA;EACA,0CAAA;EACA,8BAAA;EACA,2BAAA;EACA,qBAAA;EACA,8CAAA;AAKF;AAHE;EACE,iDAAA;EACA,oDAAA;AAKJ;;AADA;EACE,4CAAA;AAIF;;AADA;EACE,mCAAA;EACA,6BAAA;EACA,2BAAA;EACA,mEAAA;EACA,qBAAA;AAIF;;AADA,+DAAA;AAEA;EACE,oBAAA;AAGF;;AAAA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AAGF;;AAAA;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,oBAAA;EACA,gBAAA;AAGF;;AAAA;EACE,kBAAA;EACA,gBAAA;EACA,wDAAA;EACA,+BAAA;EACA,8BAAA;EACA,yCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAGF;;AAAA;EACE,6BAAA;EACA,2BAAA;EACA,+BAAA;EACA,0BAAA;AAGF;;AAAA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,qBAAA;EACA,8BAAA;EACA,yCAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AAGF;AADE;EACE,mCAAA;EACA,2BAAA;AAGJ;;AACA;EACE,4BAAA;EACA,+BAAA;EACA,YAAA;AAEF;;AACA;EACE,6BAAA;EACA,mCAAA;EACA,2BAAA;EACA,8BAAA;AAEF;;AACA,+DAAA;AAEA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,oBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,wDAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,+BAAA;EACA,mCAAA;EACA,yCAAA;AACF;AACE;EACE,2BAAA;EACA,+BAAA;AACJ;;AAGA,+DAAA;AAEA;EACE,uBAAA;EACA,eAAA;EACA,mCAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;AADF;AAGE;EACE,mBAAA;EACA,gBAAA;EACA,6BAAA;AADJ;AAIE;EACE,mCAAA;EACA,0BAAA;EACA,cAAA;AAFJ;AAKE;EACE,8BAAA;AAHJ;AAII;EAAO,+BAAA;AADX;;AAKA;EACE,sBAAA;EACA,UAAA;EACA,gBAAA;AAFF;;AAKA;EACE,iBAAA;EACA,mCAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AAFF;AAIE;EACE,YAAA;EACA,kBAAA;EACA,OAAA;EACA,+BAAA;EACA,gBAAA;AAFJ;;AAMA;EACE;IACE,mCAAA;IACA,0BAAA;IACA,cAAA;EAHF;AACF","sourcesContent":["/* ─── Timeline / Experience ──────────────────────────────── */\n\n.experience-section {\n  margin-top: 64px;\n  padding: 80px 10%;\n  background-color: var(--bg-surface);\n\n  @media (max-width: 768px) { padding: 60px 5%; }\n}\n\n.experience-header {\n  text-align: center;\n  margin-bottom: 56px;\n\n  h1 {\n    font-size: 2rem;\n    font-weight: 700;\n    letter-spacing: -0.5px;\n    margin: 0 0 12px;\n    color: var(--text) !important;\n  }\n}\n\n.experience-rule {\n  width: 48px;\n  height: 3px;\n  background: var(--accent);\n  border-radius: 2px;\n  margin: 0 auto;\n}\n\n/* ── Vertical Timeline lib overrides ─────────────────────── */\n\n.vertical-timeline::before {\n  background: var(--border) !important;\n  width: 2px !important;\n}\n\n.vertical-timeline-element-icon {\n  background: var(--accent) !important;\n  box-shadow: 0 0 0 3px var(--accent-soft), 0 0 0 5px var(--border) !important;\n\n  svg { color: #fff !important; }\n}\n\n.svg-inline--fa { color: #fff !important; }\n\n.vertical-timeline-element-content {\n  background: var(--bg-card) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: 10px !important;\n  box-shadow: none !important;\n  padding: 0 !important;\n  transition: border-color 0.2s, box-shadow 0.2s;\n\n  &:hover {\n    border-color: rgba(96, 165, 250, 0.35) !important;\n    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.3) !important;\n  }\n}\n\n.vertical-timeline-element-content-arrow {\n  border-right-color: var(--border) !important;\n}\n\n.vertical-timeline-element-date {\n  color: var(--text-muted) !important;\n  font-size: 0.78rem !important;\n  font-weight: 600 !important;\n  font-family: \"SF Mono\", \"Fira Code\", Consolas, monospace !important;\n  opacity: 1 !important;\n}\n\n/* ── Card inner layout ───────────────────────────────────── */\n\n.tl-header {\n  padding: 20px 20px 0;\n}\n\n.tl-title-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.tl-title {\n  font-size: 1rem !important;\n  font-weight: 700 !important;\n  color: var(--text) !important;\n  margin: 0 !important;\n  line-height: 1.3;\n}\n\n.tl-duration {\n  font-size: 0.68rem;\n  font-weight: 700;\n  font-family: \"SF Mono\", \"Fira Code\", Consolas, monospace;\n  color: var(--accent) !important;\n  background: var(--accent-soft);\n  border: 1px solid rgba(96, 165, 250, 0.2);\n  border-radius: 4px;\n  padding: 2px 8px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.tl-company {\n  font-size: 0.85rem !important;\n  font-weight: 500 !important;\n  color: var(--accent) !important;\n  margin: 4px 0 0 !important;\n}\n\n.tl-company-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  text-decoration: none;\n  background: var(--accent-soft);\n  border: 1px solid rgba(96, 165, 250, 0.3);\n  border-radius: 6px;\n  padding: 2px 8px;\n  transition: background 0.2s, border-color 0.2s;\n\n  &:hover {\n    background: rgba(96, 165, 250, 0.2);\n    border-color: var(--accent);\n  }\n}\n\n.tl-company-link-icon {\n  font-size: 0.6rem !important;\n  color: var(--accent) !important;\n  opacity: 0.8;\n}\n\n.tl-description {\n  font-size: 0.85rem !important;\n  color: var(--text-muted) !important;\n  line-height: 1.6 !important;\n  margin: 10px 20px 0 !important;\n}\n\n/* ── Tech tags ───────────────────────────────────────────── */\n\n.tl-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding: 12px 20px 0;\n}\n\n.tl-tag {\n  font-size: 0.68rem;\n  font-weight: 700;\n  font-family: \"SF Mono\", \"Fira Code\", Consolas, monospace;\n  padding: 2px 8px;\n  border-radius: 4px;\n  background: transparent;\n  border: 1px solid var(--border);\n  color: var(--text-muted) !important;\n  transition: border-color 0.2s, color 0.2s;\n\n  &:hover {\n    border-color: var(--accent);\n    color: var(--accent) !important;\n  }\n}\n\n/* ── Collapsible missions ────────────────────────────────── */\n\n.tl-missions {\n  padding: 12px 12px 12px;\n  margin-top: 8px;\n  border-top: 1px solid var(--border);\n}\n\n.tl-section {\n  margin-bottom: 2px;\n}\n\n.tl-section-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 7px 10px;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  text-align: left;\n  transition: background 0.15s;\n\n  span {\n    font-size: 0.825rem;\n    font-weight: 600;\n    color: var(--text) !important;\n  }\n\n  svg {\n    color: var(--text-muted) !important;\n    font-size: 1rem !important;\n    flex-shrink: 0;\n  }\n\n  &:hover {\n    background: var(--accent-soft);\n    span { color: var(--accent) !important; }\n  }\n}\n\n.tl-task-list {\n  margin: 4px 0 8px 16px;\n  padding: 0;\n  list-style: none;\n}\n\n.tl-task {\n  font-size: 0.8rem;\n  color: var(--text-muted) !important;\n  line-height: 1.5;\n  padding: 3px 0 3px 12px;\n  position: relative;\n\n  &::before {\n    content: \"›\";\n    position: absolute;\n    left: 0;\n    color: var(--accent) !important;\n    font-weight: 700;\n  }\n}\n\n@media screen and (max-width: 1170px) {\n  .vertical-timeline-element-date {\n    color: var(--text-muted) !important;\n    margin-top: 8px !important;\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
